import { scopedAuthRequest, msalInstance } from '../config/azureAd';
import axiosRetry from 'axios-retry';
import { success, error } from './utils';
import axios from 'axios';

export const createFetchActions = (config) => async (dispatch, getState) => {
  const MillisecondsToSecondsFactor = 1000;
  const FiveMinutesInSeconds = 300;

  const activeAccount =
    msalInstance.activeAccount || (msalInstance.getAllAccounts() || [])[0];

  // MSAL will grab a non-cached token based on the access token, not the id token.
  // The Id token can expire before the access token.
  // A non expired Id token is needed based on API setup with Users API, so force
  // a non-cached token call if within 5 minutes of expiration.
  const forceRefreshToken =
    activeAccount?.idTokenClaims?.exp <
    Date.now() / MillisecondsToSecondsFactor + FiveMinutesInSeconds;

  let idToken;
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...scopedAuthRequest,
      account: activeAccount,
      forceRefresh: forceRefreshToken,
    });
    idToken = response.idToken;
  } catch (e) {
    await msalInstance.loginRedirect();
  }

  dispatch({ ...config.actionPayload, type: config.startAction });

  let body = {};
  let headers = {
    Pragma: 'no-cache',
  };
  if (config.files) {
    const form = new FormData();
    for (let index = 0; index < config.files.length; index++) {
      const element = config.files[index];
      form.append(element.name, element.file);
    }
    form.append('model', JSON.stringify(config.body));
    body = form;
  } else {
    body = JSON.stringify(config.body);
    headers = {
      ...headers,
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    };
  }

  //TODO: move querystring building into here from callers
  const queryStringToAppend = '';

  const axiosConfig = {
    method: config.method ?? 'GET',
    data: body,
    url: queryStringToAppend !== '' ? `${url}${queryStringToAppend}` : config.url,
    cancelToken: config.cancelToken ?? null,
    responseType: config.responseType ?? 'json',
    headers: { ...headers },
  };

  axiosRetry(axios, {
    retries: config.retryCount ?? 0,
    retryCondition: (_error) =>
      _error?.request?.responseURL?.includes(axiosConfig.url),
    retryDelay: () => 3000,
  });

  return axios(axiosConfig)
    .then((payload) => {
      dispatch({ ...config.actionPayload, type: success(config.startAction), payload: payload.data });
      return payload;
    })
    .catch((payload) => {
      if (axios.isCancel(payload)) return;
      dispatch({ ...config.actionPayload, type: error(config.startAction) });
      return Promise.reject(payload);
    });
};